// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ForgotPassword as ForgotPasswordUI, PageLoadingSpinner } from 'ui_kit_qmd'
import { validateEmail } from '../../utils/common'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { reset } from '../../store/forgotPassword/forgotPasswordActions'
import { resetPassword } from '../../store/forgotPassword/forgotPasswordThunk'

export const ForgotPassword = memo(() => {
  const [emailValue, setEmailValue] = useState('')
  const [emailError, setEmailError] = useState('')
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.forgotPassword.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const resetSuccess = useSelector((state) => state.forgotPassword.resetSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loginSuccess = useSelector((state) => state.auth.accessToken)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetEmail = useCallback((value) => {
    setEmailValue(value)
    setEmailError('')
  }, [])
  useEffect(() => {
    dispatch(reset())
  }, [])
  const onPrimaryClick = useCallback(() => {
    if (resetSuccess) {
      navigate('/')
      dispatch(reset())
      return
    }
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setEmailError(false)
    let isError = false
    if (!emailValue) {
      isError = true
      setEmailError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Email'))
    } else if (!validateEmail(emailValue)) {
      isError = true
      setEmailError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'email'))
    }
    if (!isError) {
      dispatch(resetPassword({ Email: emailValue }))
    }
  }, [dispatch, emailValue, navigate, resetSuccess])
  useEffect(() => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const handleEnterPressEvent = (e) => {
      if (e.key === 'Enter') {
        onPrimaryClick()
      }
    }
    window.addEventListener('keyup', handleEnterPressEvent)
    return () => window.removeEventListener('keyup', handleEnterPressEvent)
  }, [emailValue])
  useEffect(() => {
    if (loginSuccess) {
      navigate('/management')
    }
  }, [loginSuccess])
  const onBackToLogin = useCallback(() => {
    navigate('/')
    dispatch(reset())
  }, [dispatch, navigate])

  if (loading) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <PageLoadingSpinner />
      </div>
    )
  }

  return (
    <ForgotPasswordUI
      emailError={emailError}
      emailValue={emailValue}
      resetSuccess={resetSuccess}
      onSetEmail={onSetEmail}
      onBackToLogin={onBackToLogin}
      onPrimaryClick={onPrimaryClick}
    />
  )
})
